import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../../../styles/components/project.scss";
import CustomCursor from "../../Cursor";
import { Link } from "react-router-dom";
import ImageFull1 from "../../../media/web-development/Fluff/fluff-full-1.png";
import ImageFull2 from "../../../media/web-development/Fluff/fluff-full-2.png";

export default function Fluff() {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="project-focus spacing-block" style={{ paddingTop: "10vh" }}>
      <div className="content">
        <h2 className="title text-6xl">Fluff</h2>
        <h3 className="year text-4xl">2020</h3>
        {/* IMAGES */}
        <div className="images">
          {/* FULL */}
          <div className="row">
            <div className="col-full">
              <img src={ImageFull1} alt="" />
            </div>
          </div>
          {/* END FULL */}
        </div>
        {/* END IMAGES */}
        {/* DESCRIPTION */}
        <div className="description">
          <h4 className="text-4xl">{t("web_development.fluff.title")}</h4>
          <p className="text-2xl">{t("web_development.fluff.text")}</p>
        </div>

        {/* IMAGES */}
        <div className="images">
          {/* FULL */}
          <div className="row">
            <div className="col-full">
              <img src={ImageFull2} alt="" />
            </div>
          </div>
          {/* END FULL */}
        </div>
        {/* END IMAGES */}
        <Link to="/web-development" style={{ color: "inherit" }}>
          <h3 className="close-text text-4xl animated-cursor">
            {t("web_development.back")}
          </h3>
        </Link>
      </div>
      <CustomCursor />
    </div>
  );
}
